export class BloqueoModuloError extends Error {
    constructor(mesasage: string) {
        super(mesasage);
        this.name = 'BloqueoModuloError';

        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, BloqueoModuloError);
        }
    }
}
